<div>
	<mat-toolbar color="primary" class="toolbar" *ngIf="(isLoggedIn$ |async) && showWholeMenu">
		<button mat-icon-button (click)="sidenav.toggle()">
			<mat-icon>menu</mat-icon>
		</button>
		<span>
			<a mat-button (click)="loadDashboardViaMsinLogo()" style="color:white" routerLink="/children/search">
				<img class="login-logo" alt="MSIN Logo" src="../../../assets/images/MSIN-Logo_Color-White-Text.png" />
			</a>
		</span>

		<span class="whitespace-spacer"></span>
		<span></span>
		<span class="whitespace-spacer"></span>
		<a mat-button [matMenuTriggerFor]="dropdown" style="color:white">
			<mat-icon>person</mat-icon>
			{{loggedInUserName}}
			<mat-icon>more_vert</mat-icon>
		</a>
		<mat-menu #dropdown>
			<button mat-menu-item routerLink="/account/user-profile">
				<mat-icon>person</mat-icon>
				User Profile
			</button>
			<button mat-menu-item (click)="performLogout()">
				<mat-icon>logout</mat-icon>
				Log out
			</button>
		</mat-menu>
	</mat-toolbar>

	<mat-sidenav-container fullscreen autosize [style.marginTop.px]="mobileQuery.matches ? 56 : 50">
		<mat-sidenav *ngIf="showWholeMenu" #sidenav fixedTopGap="56" [fixedInViewport]="mobileQuery.matches"
			[mode]="mobileQuery.matches ? 'over' : 'side'">

			<mat-nav-list>
				<a *ngIf="accessService.hasMenuAccess('Workbench') | async" mat-list-item dashboard
					(click)="getworkbenchCounts();showMenu[0] = !showMenu[0]">
					<i class="theme-font-color fa fa-wrench theme-font-color"></i>
					<!-- <mat-icon>build</mat-icon> -->
					<span class="span-icon-padding theme-font-color">Workbench</span>
					<mat-icon class="menu-button theme-font-color theme-font-color"
						[ngClass]="{'rotated' : showMenu[0]}">
						expand_more</mat-icon>
				</a>

				<div *ngIf="showMenu[0]" class="submenu" [ngClass]="{'expanded' : showMenu[0]}">
					<a mat-list-item *ngIf="accessService.hasAccess('workbench/queued') | async"
						routerLink="/workbench/queued"><i class="theme-font-color fa fa-envelope-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Queued&nbsp;&nbsp;</span>
						<span>
							<span class="badge" *ngIf="!loading">{{inboxNodesCount}}</span>
							<span class="badge" *ngIf="loading"><i class="fa fa-refresh fa-spin"></i></span>
						</span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('workbench/my-tasks') | async"
						routerLink="/workbench/my-tasks"><i class="theme-font-color fa fa-envelope-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">My
							Tasks&nbsp;&nbsp;</span>
						<span>
							<span class="badge" *ngIf="!loading">{{inProgressNodesCount}}</span>
							<span class="badge" *ngIf="loading"><i class="fa fa-refresh fa-spin"></i></span>
						</span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('workbench/my-involved') | async"
						routerLink="/workbench/my-involved"><i class="theme-font-color fa fa-share fa-fw"></i><span
							class="span-icon-padding theme-font-color">My
							Involved&nbsp;&nbsp;</span>
						<span>
							<span class="badge" *ngIf="!loading">{{outboxNodesCount}}</span>
							<span class="badge" *ngIf="loading"><i class="fa fa-refresh fa-spin"></i></span>
						</span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('workbench/my-archive') | async"
						routerLink="/workbench/my-archive"><i class="theme-font-color fa fa-archive fa-fw"></i><span
							class="span-icon-padding theme-font-color">My
							Archive</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('workbench/manage') | async"
						routerLink="/workbench/manage"><i class="theme-font-color fa fa-address-book-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Manage</span></a>
				</div>

				<a *ngIf="accessService.hasMenuAccess('COE') | async" mat-list-item
					(click)="showMenu[1] = !showMenu[1]">
					<!-- <mat-icon>post_add</mat-icon> -->
					<i class="theme-font-color fa fa-book fa-fw theme-font-color"></i>
					<span class="span-icon-padding theme-font-color">COE</span>
					<mat-icon class="menu-button theme-font-color theme-font-color"
						[ngClass]="{'rotated' : showMenu[1]}">
						expand_more</mat-icon>
				</a>
				<div *ngIf="showMenu[1]" class="submenu" [ngClass]="{'expanded' : showMenu[1]}">
					<!--routerLink="/coe/search"-->
					<a mat-list-item *ngIf="accessService.hasAccess('coe/search') | async" routerLink="/coe/search">
						<i class="theme-font-color fa fa-search fa-fw"></i>
						<span class="span-icon-padding theme-font-color">Search COE</span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('coe/review-log') | async"
						routerLink="/coe/review-log"><i class="theme-font-color fa fa-search fa-fw"></i><span
							class="span-icon-padding theme-font-color">COE Review Log</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('coe/ecoe') | async" routerLink="/coe/ecoe"><i
							class="theme-font-color fa fa-magic fa-fw"></i><span
							class="span-icon-padding theme-font-color">Create eCOE</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('coe/papercoe') | async"
						routerLink="/coe/papercoe"><i class="theme-font-color fa fa-file-text-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Enter Paper COE</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('coe/print-bulk-coes') | async"
						routerLink="/coe/print-bulk-coes"><i class="theme-font-color fa fa-book fa-fw"></i><span
							class="span-icon-padding theme-font-color">Print Bulk COEs</span></a>
				</div>

				<a *ngIf="accessService.hasMenuAccess('Children') | async" mat-list-item
					(click)="showMenu[2] = !showMenu[2]">
					<!-- <mat-icon>groups</mat-icon> -->
					<i class="theme-font-color fa fa-users fa-fw theme-font-color"></i>
					<span class="span-icon-padding theme-font-color">Children</span>
					<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[2]}">expand_more
					</mat-icon>
				</a>
				<div *ngIf="showMenu[2]" class="submenu" [ngClass]="{'expanded' : showMenu[2]}">
					<a mat-list-item *ngIf="accessService.hasAccess('children/search') | async"
						routerLink="/children/search"><i class="theme-font-color fa fa-search fa-fw"></i><span
							class="span-icon-padding theme-font-color">Search Children</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('children/group-enrollment') | async"
						routerLink="/children/group-enrollment"><i class="theme-font-color fa fa-shield fa-fw"></i><span
							class="span-icon-padding theme-font-color">Group
							Enrollments</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('children/group-services') | async"
						routerLink="/children/group-services"><i class="theme-font-color fa fa-book fa-fw"></i><span
							class="span-icon-padding theme-font-color">Group
							Services</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('children/group-communication-events') | async"
						routerLink="/children/group-communication-events"><i
							class="theme-font-color fa fa-commenting-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Group Communications</span></a>

					<a *ngIf="accessService.hasMenuAccess('Manage Duplicates') | async" mat-list-item
						(click)="showMenu[2.1] = !showMenu[2.1]">
						<!-- <mat-icon>groups</mat-icon> -->
						<i class="theme-font-color fa fa-address-card-o fa-fw theme-font-color"></i>
						<span class="span-icon-padding theme-font-color">Manage Duplicates</span>
						<mat-icon class="menu-button theme-font-color"
							[ngClass]="{'rotated' : showMenu[2.1]}">expand_more
						</mat-icon>
					</a>


					<div *ngIf="showMenu[2.1]" class="submenu" [ngClass]="{'expanded' : showMenu[2.1]}">
						<a mat-list-item *ngIf="accessService.hasAccess('children/deduplication') | async"
							routerLink="/children/deduplication"><i class="theme-font-color fa fa-clone fa-fw"></i><span
								class="span-icon-padding theme-font-color">Resolve Duplicates</span></a>
						<a mat-list-item *ngIf="accessService.hasAccess('children/deduplication/merge') | async"
							routerLink="/children/deduplication/merge"><i
								class="theme-font-color fa fa-compress fa-fw"></i><span
								class="span-icon-padding theme-font-color">Merge Children</span></a>
					</div>

					<a mat-list-item *ngIf="accessService.hasAccess('children/resolve-ssid') | async"
						routerLink="/children/resolve-ssid"><i class="theme-font-color fa fa-binoculars fa-fw"></i><span
							class="span-icon-padding theme-font-color">Resolve SSIDs</span></a>

				</div>

				<a *ngIf="accessService.hasMenuAccess('Child Reports') | async" mat-list-item
					(click)="showMenu[3] = !showMenu[3]">
					<!-- <mat-icon>format_list_bulleted</mat-icon> -->
					<i class="theme-font-color fa fa-th-list fa-fw theme-font-color"></i>
					<span class="span-icon-padding theme-font-color">Child Reports</span>
					<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[3]}">expand_more
					</mat-icon>
				</a>
				<div *ngIf="showMenu[3]" class="submenu" [ngClass]="{'expanded' : showMenu[3]}">
					<a mat-list-item *ngIf="accessService.hasAccess('reports/instant-eligibility-counts') | async"
						routerLink="/reports/instant-eligibility-counts"><i
							class="theme-font-color fa fa-money fa-fw"></i><span
							class="span-icon-padding theme-font-color">Counts</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('reports/enrollment-report') | async"
						routerLink="/reports/enrollment-report"><i
							class="theme-font-color fa fa-list-alt fa-fw"></i><span
							class="span-icon-padding theme-font-color">Enrollments</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('reports/student-service-lists') | async"
						routerLink="/reports/student-service-lists"><i
							class="theme-font-color fa fa-server fa-fw"></i><span
							class="span-icon-padding theme-font-color">Services</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('reports/academic-risk-report') | async"
						routerLink="/reports/academic-risk-report"><i
							class="theme-font-color fa fa-exclamation-triangle fa-fw"></i><span
							class="span-icon-padding theme-font-color">Academic Risk</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('reports/pfs-report') | async"
						routerLink="/reports/pfs-report"><i class="theme-font-color fa fa-product-hunt fa-fw"></i><span
							class="span-icon-padding theme-font-color">PFS</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('reports/communication-events-report') | async"
						routerLink="/reports/communication-events-report"><i
							class="theme-font-color fa fa-comments-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Communication Events</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('reports/graduation-report') | async"
						routerLink="reports/graduation-report"><i
							class="theme-font-color fa fa-graduation-cap fa-fw"></i><span
							class="span-icon-padding theme-font-color">Graduation</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('reports/ina-ilp-report') | async"
						routerLink="/reports/ina-ilp-report"><i class="theme-font-color fa fa-sitemap fa-fw"></i><span
							class="span-icon-padding theme-font-color">INA/ILP</span></a>
				</div>


				<a *ngIf="accessService.hasMenuAccess('Data Monitoring Reports') | async" mat-list-item
					(click)="showMenu[4] = !showMenu[4]">
					<!-- <mat-icon>pie_chart</mat-icon> -->
					<i class="theme-font-color fa fa-pie-chart fa-fw theme-font-color"></i>
					<span class="span-icon-padding theme-font-color">Monitoring Reports</span>
					<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[4]}">expand_more
					</mat-icon>
				</a>
				<div *ngIf="showMenu[4]" class="submenu" [ngClass]="{'expanded' : showMenu[4]}">


					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/provisional-schools') | async"
						routerLink="/data-monitoring-reports/provisional-schools"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Provisonal Schools</span></a>

					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/grade-age-alignment') | async"
						routerLink="/data-monitoring-reports/grade-age-alignment"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Grade Age Alignment</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/r-enrolled-missing-ssid') | async"
						routerLink="/data-monitoring-reports/r-enrolled-missing-ssid"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">R Enrolled, Missing SSID</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/missing-withdrawal-date') | async"
						routerLink="/data-monitoring-reports/missing-withdrawal-date"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Missing W Data</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/missing-service-end-date') | async"
						routerLink="/data-monitoring-reports/missing-service-end-date"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Missing SE Data</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/r-enrollment-not-eip') | async"
						routerLink="/data-monitoring-reports/r-enrollment-not-eip"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">R Enrolled, Not EIP</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/n-enrollment-not-eip') | async"
						routerLink="/data-monitoring-reports/n-enrollment-not-eip"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">N Enrolled, Not EIP</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('data-monitoring-reports/eip-n-enrollment') | async"
						routerLink="/data-monitoring-reports/eip-n-enrollment"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">EIP, Missing Enrollment</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('data-monitoring-reports/qad-age-eligible') | async"
						routerLink="/data-monitoring-reports/qad-age-eligible"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">QAD Age Eligible</span>
					</a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/duplicate-enrollment-line') | async"
						routerLink="/data-monitoring-reports/duplicate-enrollment-line"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Duplicate Enrollment</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/duplicate-service') | async"
						routerLink="/data-monitoring-reports/duplicate-service"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Duplicate Service</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/missing-departure-date-summer-intersession-service') | async"
						routerLink="/data-monitoring-reports/missing-departure-date-summer-intersession-service"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Not Served S/I</span></a>
					<a mat-list-item
						*ngIf="accessService.hasAccess('data-monitoring-reports/eligible-enrolled-not-served') | async"
						routerLink="/data-monitoring-reports/eligible-enrolled-not-served"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color">Not Served, Enr/EiP</span></a>
				</div>

				<a *ngIf="accessService.hasMenuAccess('SDP Reports') | async" mat-list-item
					(click)="showMenu[4.5] = !showMenu[4.5]">
					<!-- <mat-icon>folder_open</mat-icon> -->
					<i class="theme-font-color fa fa-folder-open fa-fw theme-font-color"></i>
					<span class="span-icon-padding theme-font-color">SDP 2026 Reports</span>
					<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[5]}">expand_more
					</mat-icon>
				</a>
				<div *ngIf="showMenu[4.5]" class="submenu" [ngClass]="{'expanded' : showMenu[4.5]}">
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo1') | async" routerLink="/sdp/mpo1">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of K-12 students who participated in services mapped to MPO 1.0.">
								MPO 1.0</button><!-- [matTooltipPosition]="position.value!" --></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo2') | async" routerLink="/sdp/mpo2">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of K-12 students who participated in services mapped to MPO 2.0.">
								MPO 2.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo4.1') | async" routerLink="/sdp/mpo4.1">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of instructional services that incorporate SEL.">
								MPO 4.1</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo5') | async" routerLink="/sdp/mpo5">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of 9-12 students who participated in case management services mapped to MPO 5.0.">
								MPO 5.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo6') | async" routerLink="/sdp/mpo6">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of 9-12 students who participated in credit accrual services mapped to MPO 6.0.">
								MPO 6.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo7') | async" routerLink="/sdp/mpo7">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of P3-P5 and TK students who participated in school readiness services mapped to MPO 7.0.">
								MPO 7.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo9') | async" routerLink="/sdp/mpo9">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in CTE/job training services mapped to MPO 9.0.">
								MPO 9.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo10') | async" routerLink="/sdp/mpo10">
						<i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in English literacy services mapped to MPO 10.0.">
								MPO 10.0</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo10.1') | async" routerLink="/sdp/mpo10.1">
						<!--  --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in GED services mapped to MPO 10.1.">
								MPO 10.1</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo11') | async" routerLink="/sdp/mpo11">
						<!-- --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Count of mental health workshops mapped to MPO 11.0.">
								MPO 11.0</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo11.1') | async" routerLink="/sdp/mpo11.1">
						<!--  --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of children and youths who accessed health services.">
								Health Dashboard (MPO 11.1)</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('sdp/mpo13') | async" routerLink="/sdp/mpo13">
						<!--   --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of instructional services that include culturally sustaining pedagogy.">MPO
								13.0</button></span>
					</a>
				</div>



				<a *ngIf="accessService.hasMenuAccess('SSDP Reports') | async" mat-list-item
					(click)="showMenu[5] = !showMenu[5]">
					<!-- <mat-icon>folder_open</mat-icon> -->
					<i class="theme-font-color fa fa-folder-open fa-fw theme-font-color"></i>
					<span class="span-icon-padding theme-font-color">SSDP Reports</span>
					<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[5]}">expand_more
					</mat-icon>
				</a>
				<div *ngIf="showMenu[5]" class="submenu" [ngClass]="{'expanded' : showMenu[5]}">
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo1') | async" routerLink="/ssdp/mpo1"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of K-10 students who participated in services mapped to MPO 1.0.">MPO
								1.0</button><!-- [matTooltipPosition]="position.value!" --></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo2') | async" routerLink="/ssdp/mpo2"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of K-10 students who participated in services mapped to MPO 2.0.">MPO
								2.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo5-6') | async" routerLink="/ssdp/mpo5-6"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of 9th grade students who participated in services mapped to MPO 5.0 or 6.0.">MPO
								5.0, 6.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo5_1-6_1') | async"
						routerLink="/ssdp/mpo5_1-6_1"><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of 11th or 12th graders who participated in services mapped to credit accrual state service codes (3000s).">MPO
								5.1, 6.1</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo7') | async" routerLink="/ssdp/mpo7"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of P3-P5 students who participated in services mapped to MPO 7.0.">MPO
								7.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo8') | async" routerLink="/ssdp/mpo8"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of active MESRP services that incorporate a Social Emotional Component.">MPO
								8.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo9') | async" routerLink="/ssdp/mpo9"><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in services mapped to MPO 9.0.">MPO
								9.0</button></span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo9_1') | async" routerLink="/ssdp/mpo9_1">
						<!--  --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in services mapped to MPO 9.1.">MPO
								9.1</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo10') | async" routerLink="/ssdp/mpo10">
						<!--  --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in services mapped to MPO 10.0.">MPO
								10.0</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo10_1') | async" routerLink="/ssdp/mpo10_1">
						<!-- --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in services mapped to MPO 10.1.">MPO
								10.1</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo10_2') | async" routerLink="/ssdp/mpo10_2">
						<!--  --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of OSY students who participated in services mapped to MPO 10.2.">MPO
								10.2</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo11') | async" routerLink="/ssdp/mpo11">
						<!--   --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Count of the mental health workshops offered by subgrantees.">MPO
								11.0</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo11_1') | async" routerLink="/ssdp/mpo11_1">
						<!--  --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Count of the mental health referrals and treatments.">MPO
								11.1</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp/mpo13') | async" routerLink="/ssdp/mpo13">
						<!--   --><i class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of active instructional services that incorporate a Cultural Component.">MPO
								13.0</button></span>
					</a>
					<a mat-list-item routerLink="/ssdp/mpo13_1">
						<!-- *ngIf="accessService.hasAccess('ssdp/mpo13_1') | async" --><i
							class="theme-font-color fa fa-dot-circle-o fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton"
								matTooltip="Percentage of active instructional services that incorporate a Self-Pride Component.">MPO
								13.1</button></span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('ssdp-reports/ssdp-annual-report') | async"
						routerLink="/ssdp/subgrantee">
						<!-- /ssdp-reports/ssdp-annual-report --><i
							class="theme-font-color fa fa-shield fa-fw"></i><span
							class="span-icon-padding theme-font-color"><button class="hideButton" matTooltip="">SSDP
								Annual Report</button></span>
					</a>
				</div>

				<a *ngIf="accessService.hasMenuAccess('Resources') | async" mat-list-item
					(click)="showMenu[6] = !showMenu[6]">
					<!-- <mat-icon>public</mat-icon> -->
					<i class="theme-font-color fa fa-globe fa-fw theme-font-color"></i>
					<span class="span-icon-padding theme-font-color">Resources</span>
					<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[6]}">expand_more
					</mat-icon>
				</a>
				<div *ngIf="showMenu[6]" class="submenu" [ngClass]="{'expanded' : showMenu[6]}">
					<a mat-list-item *ngIf="accessService.hasAccess('cdemeo') | async" target="_blank"
						href="https://www.cde.ca.gov/sp/me/mt/programs.asp"><i
							class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">CDE/MEO</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('mep') | async" target="_blank"
						href="https://mephelpcenter.wested.org/hc/en-us"><i
							class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">MEP Help Center</span></a>

					<a mat-list-item *ngIf="accessService.hasAccess('msin') | async" target="_blank"
						href="https://mephelpcenter.wested.org/hc/en-us/categories/5774679512468-MSIN"><i
							class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">MSIN</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('userguides') | async" target="_blank"
						href="https://mephelpcenter.wested.org/hc/en-us/sections/5774987357076-User-Guides-and-Resources">&nbsp;
						&nbsp; &nbsp;<i class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">User Guides</span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('training') | async" target="_blank"
						href="https://mephelpcenter.wested.org/hc/en-us/sections/5774981875220-Training-Materials-">&nbsp;
						&nbsp; &nbsp;<i class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">Training Materials</span>
					</a>
					<a mat-list-item *ngIf="accessService.hasAccess('releasenotes') | async" target="_blank"
						href="https://mephelpcenter.wested.org/hc/en-us/sections/6220820765716-MSIN-System-Release-Communications">&nbsp;
						&nbsp; &nbsp;<i class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">Release Notes</span>
					</a>

					<a mat-list-item *ngIf="accessService.hasMenuAccess('MSIX') | async" target="_blank"
						href="https://msix.ed.gov/msix/"><i class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">MSIX</span></a>
					<a mat-list-item *ngIf="accessService.hasAccess('msixmanual') | async" target="_blank"
						href="https://mephelpcenter.wested.org/hc/en-us/articles/4415789467156-CDE-MSIX-Manual-2021">&nbsp;
						&nbsp; &nbsp;<i class="theme-font-color fa fa-external-link fa-fw"></i><span
							class="span-icon-padding theme-font-color">MSIX Manual</span>
					</a>

				</div>

				<!-- <div *ngIf="showMenu[7]" class="submenu" [ngClass]="{'expanded' : showMenu[7]}">
					<a mat-list-item *ngIf="accessService.hasAccess('school/search') | async" routerLink="/school/search">
						<i class="theme-font-color fa fa-search fa-fw"></i><span
							class="span-icon-padding theme-font-color"><a routerLink="/school/search">Search
								Schools</a></span>
					</a>
				</div>-->

				<a *ngIf="accessService.hasMenuAccess('System') | async" mat-list-item
					(click)="showMenu[8] = !showMenu[8]">
					<i class="theme-font-color fa fa-cog fa-fw"></i>
					<span class="span-icon-padding theme-font-color">System</span>
					<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[8]}">expand_more
					</mat-icon>
				</a>
				<div *ngIf="showMenu[8]" class="submenu" [ngClass]="{'expanded' : showMenu[8]}">
					<!-- <mat-list-item ><i class="theme-font-color fa fa-key fa-fw"></i><span class="span-icon-padding theme-font-color">Accounts</span></mat-list-item> -->
					<a *ngIf="accessService.hasMenuAccess('Accounts') | async" mat-list-item
						(click)="showMenu[81] = !showMenu[81]">
						<i class="theme-font-color fa fa-key fa-fw"></i>
						<span class="span-icon-padding theme-font-color">Accounts</span>
						<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[81]}">
							expand_more
						</mat-icon>
					</a>
					<div *ngIf="showMenu[81]" class="submenu" [ngClass]="{'expanded' : showMenu[81]}">
						<a mat-list-item *ngIf="accessService.hasAccess('accounts/search') | async"
							routerLink="/accounts/search"><i class="theme-font-color fa fa-search fa-fw"></i><span
								class="span-icon-padding theme-font-color">Search Accounts</span></a>
						<a mat-list-item *ngIf="accessService.hasAccess('accounts/create') | async"
							routerLink="/accounts/create"><i class="theme-font-color fa fa-plus fa-fw"></i><span
								class="span-icon-padding theme-font-color">Create Account</span></a>
						<a mat-list-item *ngIf="accessService.hasAccess('accounts/login-audits') | async"
							routerLink="/accounts/login-audits"><i
								class="theme-font-color fa fa-history fa-fw"></i><span
								class="span-icon-padding theme-font-color">Login Audits</span></a>
						<a mat-list-item *ngIf="accessService.hasAccess('accounts/roles') | async"
							routerLink="/accounts/roles"><i class="theme-font-color fa fa-check fa-fw"></i><span
								class="span-icon-padding theme-font-color">Roles</span></a>
						<!-- <a mat-list-item *ngIf="accessService.hasAccess('accounts/features') | async"
							routerLink="/accounts/features"><i class="theme-font-color fa fa-book fa-fw"></i><span
								class="span-icon-padding theme-font-color">Features</span></a> -->
						<a mat-list-item *ngIf="accessService.hasAccess('accounts/permissions') | async"
							routerLink="/accounts/permissions"><i class="theme-font-color fa fa-ban fa-fw"></i><span
								class="span-icon-padding theme-font-color">Permissions</span></a>
						<a mat-list-item *ngIf="accessService.hasAccess('email-domains/edit') | async"
							routerLink="/email-domains/edit"><i class="theme-font-color fa fa-envelope fa-fw"></i><span
								class="span-icon-padding theme-font-color">Email Domains</span></a>
						<a mat-list-item *ngIf="accessService.hasAccess('accounts/global-admin') | async"
							routerLink="/accounts/global-admin"><i
								class="theme-font-color fa fa-exclamation-triangle fa-fw"></i><span
								class="span-icon-padding theme-font-color">Global Admin</span></a>
					</div>
					<a mat-list-item *ngIf="accessService.hasAccess('administer-services/search') | async"
						routerLink="/administer-services/search"><i class="theme-font-color fa fa-plus fa-fw"></i><span
							class="span-icon-padding theme-font-color">Administer Services</span></a>

					<!--
					<a *ngIf="accessService.hasMenuAccess('Workflows') | async" mat-list-item
						(click)="showMenu[82] = !showMenu[82]">
						<i class="theme-font-color fa fa fa-list fa-fw"></i>
						<span class="span-icon-padding theme-font-color">Workflows</span>
						<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[82]}">
							expand_more
						</mat-icon>
					</a>
					-->
					<a *ngIf="accessService.hasMenuAccess('Counties') | async" mat-list-item
						(click)="showMenu[85] = !showMenu[85]" routerLink="/system/searchCounties">
						<i class="theme-font-color fa fa-map-o fa-fw"></i>
						<span class="span-icon-padding theme-font-color">Counties</span>
						<!-- <mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[85]}">
						expand_more
					</mat-icon> -->
					</a>
					<!--	<div *ngIf="showMenu[82]" class="submenu" [ngClass]="{'expanded' : showMenu[82]}">-->
					<a mat-list-item *ngIf="accessService.hasAccess('workflows/edit') | async"
						routerLink="/workflows/edit"><i class="theme-font-color fa fa-pencil fa-fw"></i><span
							class="span-icon-padding theme-font-color">Edit Workflows</span></a>
					<!--	<a mat-list-item *ngIf="accessService.hasAccess('workflows/create') | async"
							routerLink="/workflows/create"><i class="theme-font-color fa fa-plus fa-fw"></i><span
								class="span-icon-padding theme-font-color">Create Workflows</span></a>
								
						<a mat-list-item *ngIf="accessService.hasAccess('workflows/all') | async"
							routerLink="/workflows/all"><i class="theme-font-color fa fa-eye fa-fw"></i><span
								class="span-icon-padding theme-font-color">All
								Workbench Items</span></a>-->
					<!--	</div> -->
					<a mat-list-item *ngIf="accessService.hasAccess('system/organization') | async"
						routerLink="/system/organization"><i class="theme-font-color fa fa-home fa-fw"></i><span
							class="span-icon-padding theme-font-color">Organizations
						</span></a>
					<!-- <a *ngIf="accessService.hasMenuAccess('SystemSchools') | async" mat-list-item
						(click)="showMenu[83] = !showMenu[83]">
						<i class="theme-font-color fa fa-building fa-fw"></i>
						<span class="span-icon-padding theme-font-color">Schools</span>
						<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[83]}">
							expand_more
						</mat-icon>
					</a>
					<div *ngIf="showMenu[83]" class="submenu" [ngClass]="{'expanded' : showMenu[83]}">
						<a mat-list-item *ngIf="accessService.hasAccess('school/create') | async"
							routerLink="/school/create-school"><i class="theme-font-color fa fa-plus fa-fw"></i><span
								class="span-icon-padding theme-font-color">Create Schools</span></a>
					</div> -->
					<a *ngIf="accessService.hasMenuAccess('Schools') | async" routerLink="/school/search" mat-list-item
						(click)="showMenu[7] = !showMenu[7]">
						<!-- <mat-icon>school</mat-icon> -->
						<i class="theme-font-color fa fa-university fa-fw theme-font-color"></i>
						<span class="span-icon-padding theme-font-color">Schools</span>
						<!-- <mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[7]}">expand_more
					</mat-icon>-->
					</a>

					<a *ngIf="accessService.hasMenuAccess('School Districts') | async" mat-list-item
						(click)="showMenu[84] = !showMenu[84]" routerLink="/system/schoolDistricts">
						<i class="theme-font-color fa fa-map-o fa-fw"></i>
						<span class="span-icon-padding theme-font-color">School
							Districts</span>
						<!-- <mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[84]}">
							expand_more
						</mat-icon> -->
					</a>

					<a *ngIf="accessService.hasRole('System Administrator') | async" mat-list-item
						routerLink="/system/help-texts">
						<i class="theme-font-color fa fa-info fa-fw"></i>
						<span class="span-icon-padding theme-font-color">Help Texts</span>
					</a>

					<!-- <div *ngIf="showMenu[84]" class="submenu" [ngClass]="{'expanded' : showMenu[84]}">
						<a mat-list-item *ngIf="accessService.hasAccess('system/schoolDistricts') | async"
							routerLink="/system/schoolDistricts"><i
								class="theme-font-color fa fa-search fa-fw"></i><span
								class="span-icon-padding theme-font-color"><a
									routerLink="/system/schoolDistricts">Search & Create School District</a></span>
						</a> -->
					<!-- <a mat-list-item *ngIf="accessService.hasAccess('system/schoolCreateDistricts') | async"
							routerLink="/system/schoolCreateDistricts"><i
								class="theme-font-color fa fa-plus fa-fw"></i><span
								class="span-icon-padding theme-font-color"><a
									routerLink="/system/schoolCreateDistricts">Create School District</a></span>
						</a> 
					</div>-->


					<!--<div *ngIf="showMenu[85]" class="submenu" [ngClass]="{'expanded' : showMenu[85]}">
						<a mat-list-item *ngIf="accessService.hasAccess('county/search') | async"
							routerLink="/system/counties"><i class="theme-font-color fa fa-search fa-fw">								
							</i><span
								class="span-icon-padding theme-font-color">Counties</span>
						</a>
						<a mat-list-item *ngIf="accessService.hasAccess('county/create') | async"
							routerLink="/county/create"><i class="theme-font-color fa fa-plus fa-fw"></i><span
								class="span-icon-padding theme-font-color">Create Counties</span></a>
						
					</div>

					<a *ngIf="accessService.hasMenuAccess('Persons') | async" mat-list-item
						(click)="showMenu[86] = !showMenu[86]">
						<i class="theme-font-color fa fa-user-o fa-fw"></i>
						<span class="span-icon-padding theme-font-color">Persons</span>
						<mat-icon class="menu-button theme-font-color" [ngClass]="{'rotated' : showMenu[86]}">
							expand_more
						</mat-icon>
					</a>
					<div *ngIf="showMenu[86]" class="submenu" [ngClass]="{'expanded' : showMenu[86]}">
						<a mat-list-item *ngIf="accessService.hasAccess('persons/search') | async"
							routerLink="/persons/search"><i class="theme-font-color fa fa-search fa-fw"></i><span
								class="span-icon-padding theme-font-color">Search Persons</span></a>
						<a mat-list-item *ngIf="accessService.hasAccess('persons/create') | async"
							routerLink="/persons/create"><i class="theme-font-color fa fa-plus fa-fw"></i><span
								class="span-icon-padding theme-font-color">Create Person</span></a>
					</div>
					-->

					<!-- <a mat-list-item *ngIf="accessService.hasAccess('locations/edit') | async"
						routerLink="/locations/edit"><i class="theme-font-color fa fa-road fa-fw"></i><span
							class="span-icon-padding theme-font-color">Edit
							Locations</span></a>
					 <a mat-list-item *ngIf="accessService.hasAccess('dashboard/edit') | async"
						routerLink="/dashboard/edit"><i class="theme-font-color fa fa-home fa-fw"></i><span
							class="span-icon-padding theme-font-color">Edit
							Dashboard</span></a> -->
				</div>
			</mat-nav-list>
		</mat-sidenav>
		<div class="sidenav-content padding-top padding-bottom">
			<router-outlet></router-outlet>
		</div>
	</mat-sidenav-container>
</div>